export const common = {
  login: '登录',
  register: '注册',
  logout: '退出登录',
  confirm: '确认',
  cancel: '取消',
  submit: '提交',
  save: '保存',
  delete: '删除',
  edit: '编辑',
  add: '添加',
  search: '搜索',
  loading: '加载中...',
  retry: '重新加载',
  noData: '暂无数据',
  error: '出错了',
  success: '成功',
  back: '返回',
  next: '下一步',
  prev: '上一步',
  done: '完成',
  more: '更多',
  all: '全部',
  today: '今天',
  yesterday: '昨天',
  week: '本周',
  month: '本月',
  year: '今年',
  home: '首页',
  market: '行情',
  lockPrice: '锁价',
  orders: '订单',
  profile: '我的',
  language: '语言',
  zhCN: '简体中文',
  en: 'English',
  zhTW: '繁體中文',
  serviceTerms: '服务条款',
  privacyPolicy: '隐私政策',
  riskWarning: '风险提示',
  phone: '手机号',
  password: '密码',
  confirmPassword: '确认密码',
  forgotPassword: '忘记密码?',
  noAccount: '尚未有账号?',
  hasAccount: '已有账号?',
  registerNow: '立即注册',
  loginNow: '立即登录',
  placeholderPhone: '请输入手机号',
  placeholderPassword: '请输入密码',
  errorPhoneEmpty: '请输入手机号',
  errorPhoneFormat: '请输入正确的11位手机号',
  errorPasswordEmpty: '请输入密码',
  errorPasswordLength: '密码至少6位',
  errorPasswordMismatch: '两次密码不一致',
  errorAgreeTerms: '请同意用户协议',
  errorInvalidCredentials: '手机号或密码错误，请重试',
  errorEmailNotConfirmed: '账号尚未验证，请去后台关闭邮箱验证后再试',
  errorLoginFailed: '登录失败：{{message}}',
  errorAccountExists: '该手机号已注册，请直接登录',
  errorRateLimit: '注册请求太频繁了，请稍等约 1 小时后再试',
  errorRegisterFailed: '注册失败：{{message}} (code: {{code}}, status: {{status}})',
  errorRegisterSuccessNoLogin: '注册成功但未自动登录，请手动登录',
  loginSuccess: '登录成功',
  registerSuccess: '注册成功',
  welcomeLogin: '欢迎登录',
  welcomeRegister: '创建账号',
  registerSubtitle: '开启您的黄金投资之旅',
  agreeTerms: '我已阅读并同意',
  userAgreement: '《用户服务协议》',
  privacyPolicyDoc: '《隐私政策》',
  resetPasswordHint: '请联系客服重置密码',
  confirmLogout: '确认退出登录？',
  userServiceAgreement: '用户服务协议',
  ok: '确定',
  close: '关闭',
  copy: '复制',
  copied: '已复制',
  amount: '金额',
  date: '日期',
  status: '状态',
  detail: '详情',
  notice: '公告',
  viewAll: '查看全部',
  latestNotice: '最新公告',
  noNotice: '暂无公告',
  noticeLoadFailed: '公告加载失败',
  contactCustomerService: '请联系客服重置密码',
  settings: '设置',
  accountSecurity: '账号与安全',
  notifications: '消息通知',
  general: '通用',
  changePassword: '修改登录密码',
  changePhone: '更换手机号',
  realNameVerify: '实名认证',
  verified: '已认证',
  verifyThenChange: '请通过验证码验证后修改',
  priceAlert: '金价异动提醒',
  priceAlertDesc: '价格大幅波动时通知',
  tradeAlert: '交易状态提醒',
  tradeAlertDesc: '锁价、支付、交割进度',
  systemPush: '系统消息推送',
  systemPushDesc: '公告及活动信息',
  clearCache: '清除缓存',
  cacheCleared: '缓存已清除',
  about: '关于CJJY',
};